import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('../views/pages/login.vue')
    }
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        redirect: '/index'
      },
      // ==================== 商家端路由 ====================
      {
        path: 'index',
        name: 'index',
        component: function () {
          return import('../views/pages/Index.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'product',
        name: 'product',
        component: function () {
          return import('../views/ProductView.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'order',
        name: 'order',
        component: function () {
          return import('../views/OrderView.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'shop',
        name: 'shop',
        component: function () {
          return import('../views/merchants/ShopDecoration.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'presale',
        name: 'presale',
        component: function () {
          return import('../views/merchants/PresaleManage.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'stock-warning',
        name: 'stock-warning',
        component: function () {
          return import('../views/merchants/StockWarning.vue')
        },
        meta: { role: 1 }
      },
      // ==================== 管理员端路由 ====================
      {
        path: 'admin/index',
        name: 'admin-index',
        component: function () {
          return import('../views/pages/Index.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/users',
        name: 'admin-users',
        component: function () {
          return import('../views/admin/UserManage.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/merchants',
        name: 'admin-merchants',
        component: function () {
          return import('../views/admin/MerchantManage.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/products',
        name: 'admin-products',
        component: function () {
          return import('../views/ProductView.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/categories',
        name: 'admin-categories',
        component: function () {
          return import('../views/admin/CategoryManage.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/orders',
        name: 'admin-orders',
        component: function () {
          return import('../views/OrderView.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/payment-log',
        name: 'admin-payment-log',
        component: function () {
          return import('../views/PaymentLogView.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/presale',
        name: 'admin-presale',
        component: function () {
          return import('../views/admin/PresaleManage.vue')
        },
        meta: { role: 0 }
      },
      {
        path: 'admin/stock-warning',
        name: 'admin-stock-warning',
        component: function () {
          return import('../views/admin/StockWarning.vue')
        },
        meta: { role: 0 }
      },
      // ==================== 商家钱包路由 ====================
      {
        path: 'merchant/wallet',
        name: 'merchant-wallet',
        component: function () {
          return import('../views/WalletView.vue')
        },
        meta: { role: 1 }
      },
      {
        path: 'merchant/payment-log',
        name: 'merchant-payment-log',
        component: function () {
          return import('../views/PaymentLogView.vue')
        },
        meta: { role: 1 }
      }
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const role = parseInt(localStorage.getItem('role'));

  if (to.path === '/login') {
    next();
  } else {
    if (!token) {
      next('/login');
    } else {
      if (to.meta && to.meta.role !== undefined) {
        if (to.meta.role === role) {
          next();
        } else {
          if (role === 0) {
            next('/admin/index');
          } else if (role === 1) {
            next('/index');
          } else {
            localStorage.clear();
            next('/login');
          }
        }
      } else {
        next();
      }
    }
  }
})

export default router
